import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.scss';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children the text for the button to render
 * @param {(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} props.onClick click handler
 * @param {string} [props.className] optional additional class name(s)
 * @param {boolean} [props.disabled] optional disabled state
 * @param {string|null} [props.dataTestid] optional data-testid attribute for testing
 * @param {'small' | 'medium' | 'large'} [props.size] optional size of the button
 * @param {boolean} [props.isBelowButton] optional flag to indicate if placement is below another button, which changes styling
 */
export const InteractiveTextLink = ({
  children,
  onClick,
  className = '',
  dataTestid,
  size,
  disabled,
  isBelowButton = false,
}) => (
  <button
    type="button"
    className={cx(
      styles.btn,
      className,
      size && styles[size],
      isBelowButton && styles.belowButton,
    )}
    disabled={!!disabled}
    onClick={onClick}
    data-testid={dataTestid}
  >
    {children}
  </button>
);

InteractiveTextLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  dataTestid: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  isBelowButton: PropTypes.bool,
};
